import { LucideIcon } from 'lucide-react';
import { Button } from './Button';

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const EmptyState = ({
  icon: Icon,
  title,
  description,
  action
}: EmptyStateProps) => (
  <div
    className="flex flex-col items-center justify-center py-12 px-6 text-center min-h-[400px]"
    role="region"
    aria-label="Empty state"
  >
    <div className="text-dark-muted mb-6">
      <Icon size={64} strokeWidth={1.5} />
    </div>
    <h3 className="text-lg font-semibold text-white mb-2">
      {title}
    </h3>
    <p className="text-sm text-dark-muted mb-6 max-w-sm">
      {description}
    </p>
    {action && (
      <Button onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
);
